import { Language } from "@omni/schemas/config/language.schema";
import { cn } from "@omni/utils/styles";

import { getLabel } from "@/components/General/LanguageSelector/partials/label.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { setLanguageCookie } from "@/services/cookie.service";

import { useLanguageSelectorPath } from "../../languageSelector.helper";

type Props = {
    language: Language;
    isCurrent: boolean;
    variant?: "small" | "large";
};

const LanguageListItem = ({ language, isCurrent, variant }: Props) => {
    const { t } = useGranite();

    const languageUrl = useLanguageSelectorPath(language.url);

    const handleOnClick = () => {
        setLanguageCookie(language["language-code"]);
    };

    if (isCurrent) {
        return (
            <span>
                {getLabel({ language: language, variant: variant, t: t })}
            </span>
        );
    } else {
        return (
            <a
                className={cn({
                    "current": isCurrent
                })}
                href={languageUrl}
                onClick={handleOnClick}
            >
                {getLabel({ language: language, variant: variant, t: t })}
            </a>
        );
    }
};

export { LanguageListItem };
